export default __webpack_public_path__ + "static/media/s-profile.7e831d7b.webp";